"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createJourneyComponent = void 0;
/*
* Create a quick component that applies classes to a element
* Inspired by styled components but without the bloat.
*/
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../hocs/withJourney"));
const helpers_1 = require("./helpers");
function createJourneyComponent(className, Comp) {
    return withJourney_1.default(className, (props) => {
        const componentAlreadyRendered = props.overwrite ? helpers_1.hasChildComponent({ children: props.overwrite.children }, className) : false;
        // skip our component, just render children it will show up there since one already in the children.
        if (componentAlreadyRendered) {
            return react_1.default.createElement(react_1.default.Fragment, null, props.children);
        }
        // div, h2, span
        if (typeof Comp === 'string') {
            return react_1.default.createElement(Comp, Object.assign({}, helpers_1.usePrimitiveProps(props)), [props.children]);
        }
        return react_1.default.createElement(Comp, Object.assign({}, props), props.children);
    });
}
exports.createJourneyComponent = createJourneyComponent;
